import React, { useEffect, useRef, useState } from 'react';
import { BiChevronDown, BiCheck } from 'react-icons/bi';

const KontaktFormSelect = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  options,
  required = false,
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const selected = options.find((option) => option.value === value);
  const displayLabel = selected ? selected.label : placeholder;

  return (
    <div
      ref={rootRef}
      className={`kontakt-form-select ${open ? 'is-open' : ''}`}
    >
      <input type="hidden" name={name} value={value} required={required} />
      <button
        type="button"
        id={id}
        className={`kontakt-form-select__trigger ${!value ? 'is-placeholder' : ''}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-labelledby={id}
      >
        <span className="kontakt-form-select__value">{displayLabel}</span>
        <BiChevronDown className="kontakt-form-select__chevron" aria-hidden="true" />
      </button>
      <ul
        className={`kontakt-form-select__menu ${open ? 'is-visible' : ''}`}
        role="listbox"
        aria-labelledby={id}
      >
        {options.map((option) => (
          <li key={option.value} role="none">
            <button
              type="button"
              role="option"
              aria-selected={value === option.value}
              className={`kontakt-form-select__option ${value === option.value ? 'is-selected' : ''}`}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              <span className="kontakt-form-select__option-label">{option.label}</span>
              {value === option.value && (
                <BiCheck className="kontakt-form-select__check" aria-hidden="true" />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KontaktFormSelect;
